<template>
  <div>
    <h2>{{ titleText.toUpperCase() }}</h2>
    <div class="wordHighlight" v-if="highlightWord"></div>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      default: "Statistics",
    },
    highlightWord: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
h2 {
  color: #707070;
  font-weight: 400;
  font-size: 20px;
  margin-bottom: 10px;
  text-align: left;
}
div.wordHighlight {
  width: 50px;
  height: 5px;
  border-radius: 5px;
  background-color: #49a39c;
  margin-bottom: 25px;
}
</style>
